import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('tab-list', [
  'indicator',
  'scrollable',
]);

const getTabCss = css`
  min-height: auto;
  overflow: visible;
  position: relative;
  border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);

  .${classes.indicator} {
    height: var(--cds-spacing-50);
    background-color: var(--cds-color-interactive-secondary);
    border-radius: var(--cds-border-radius-25) var(--cds-border-radius-25) 0 0;
    margin-top: calc(var(--cds-spacing-50) * -1);
  }

  .${classes.scrollable} {
    /* The new design does not have horizontal padding, and the focus state bleeds out of the tab container */

    /* 3px comes from 2px of space between the tab content and the outline + 1 px of outline */
    padding-top: 3px;
    padding-inline-start: 3px;
    margin-top: -3px;
    margin-inline-start: -3px;
  }

  @media (forced-colors: active) {
    .${classes.indicator} {
      border-bottom: 4px solid white;
      box-sizing: border-box;
    }
  }
`;

export default getTabCss;
